import ApplicationModals from '@components/modals/ApplicationModals';
import Layout from '@components/primitives/layout/Layout';
import { FC } from 'react';
import { Outlet } from 'react-router';

const PrivateRoutes: FC = () => {
    return (
        <Layout>
            <Outlet />
            <ApplicationModals />
        </Layout>
    );
};

export default PrivateRoutes;
